<template>
  <div>
    <Head title="Orders" />
    <h1 id="pg-tittle" class="page-title">{{ title }}</h1>
    <div class="toolbar">
      <search-filter v-model="form.search" class="w-full max-w-xl" @reset="reset">
        <label class="form-label" v-if="role === 'manager'">Assigned To</label>
        <select v-model="form.assigned_to" class="form-select mt-1 w-full mb-4">
          <option v-for="user in users" :key="user.id" :value="user.id" :selected="form.assigned_to == user.id">{{ user.name }}</option>
        </select>

        <label class="form-label" v-if="is_view_all_page">Status</label>
        <select v-model="form.status" v-if="is_view_all_page" class="form-select mt-1 w-full">
          <option :value="null">Any</option>
          <option value="new">New</option>
          <option value="pending">Pending</option>
          <option value="hold">On Hold</option>
          <option value="confirmed">Confirmed</option>
          <option value="dispatched">Dispatched</option>
          <option value="canceled">Pending to Cancel</option>
          <option value="cancel_completed">Cancelled</option>
        </select>
      </search-filter>
      <Datepicker v-model="form.date" class="w-full max-w-md" range :enable-time-picker="false" :partial-range="false" />
      <Link v-if="false" class="btn-indigo" href="/orders/create">
        <span>Sync</span>
        <span class="hidden md:inline">&nbsp;Orders</span>
      </Link>
    </div>
    <div class="mb-4 panel flex w-full flex-col gap-3 p-3 md:flex-row md:items-center md:justify-between" v-show="selected.length > 0">
      <span class="text-sm font-bold text-gray-700">{{ selected.length }} selected</span>
      <button v-if="selected.length > 0 && role === 'support_agent'" class="btn-indigo" @click="self_assign">
        <icon name="check" class="mr-2 w-4 h-4" :class="'inline-flex fill-white group-hover:fill-white'" /> <span class="hidden md:inline">&nbsp; Assign Myself</span>
      </button>

      <div v-else class="flex flex-col gap-2 sm:flex-row sm:items-center">
        <div class="w-full sm:w-64">
          <select v-model="mass_assigned_to" class="form-select w-full">
            <option value="0" selected>None</option>
            <option v-for="user in users" :value="user.id">{{ user.name }}</option>
          </select>
        </div>

        <button class="btn-indigo" v-on:click="mass_assign">Assign</button>
      </div>

    </div>
    <div class="table-card">
      <table class="data-table">
        <thead>
          <tr class="text-left font-bold">
            <th>
              <input id="default-checkbox" v-model="selectAll" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
            </th>
            <th>Order ID</th>
            <th>Date/Time</th>
            <th>Name</th>
            <th>Order Value</th>
            <th>PIN Code</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Status</th>
            <th>Followups</th>
            <th v-if="view === 'hold'">Hold Reason</th>
            <th>Assigned to</th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in orders.data" :id="`order_${order.id}`" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t  px-1">
              <input v-if="order.assigned_to === 0" id="default-checkbox" v-model="selected" :value="order.id" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
            </td>
            <td class="border-t">
              <Link class="flex items-center px-2 py-2 focus:text-indigo-500" :href="`/orders/${order.id}`">
                <a href="">{{ order.order_id }}</a>
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-1 py-2 focus:text-indigo-500" :href="`/orders/${order.id}`">
                <span v-if="order.sla_breach && (order.status === 'pending' || order.status === 'new' || order.status === 'hold')" class="sla-chip">{{ order.date_time }}</span>
                <span v-else>{{ order.date_time }}</span>
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-1 py-2 focus:text-indigo-500" :href="`/orders/${order.id}`">
                {{ order.name }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-1 py-2" :href="`/orders/${order.id}`" tabindex="-1">
                ₹ {{ order.value }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="px-1 py-2 text-xs" :href="`/orders/${order.id}`" tabindex="-1">
<!--                <p>{{ order.shipping_address.address_1 }}</p>-->
<!--                <p v-if="order.shipping_address.address_2">{{ order.shipping_address.address_2 }}<br /></p>-->
<!--                <p>{{ order.shipping_address.city }}</p>-->
<!--                <p>{{ order.shipping_address.state }}</p>-->
                <p>{{ order.shipping_address.zip || order.shipping_address.postcode || 'N/A' }}</p>
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-1 py-2" :href="`/orders/${order.id}`" tabindex="-1">
                {{ order.email }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-1 py-2" :href="`/orders/${order.id}`" tabindex="-1">
                {{ order.phone_number }}
              </Link>
            </td>
            <td class="border-t">
              <span class="flex items-center px-1 py-2">
                <span v-if="order.status == 'new'" class="pill_purple">New</span>
                <span v-if="order.status == 'pending'" class="pill_blue">Pending</span>
                <span v-if="order.status == 'confirmed'" class="pill_green">Confirmed</span>
                <span v-if="order.status == 'cancelled'" class="pill_red">Cancel Pending</span>
                <span v-if="order.status == 'hold'" class="pill_yellow">On Hold</span>
                <span v-if="order.status == 'dispatched'" class="pill_grey">Dispatched</span>
                <span v-if="order.status == 'cancel_completed'" class="pill_red">Canceled</span>
              </span>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-1 py-2" :href="`/orders/${order.id}`" tabindex="-1">
                {{ order.followups }}
              </Link>
            </td>
            <td v-if="view === 'hold'" class="border-t">
              <Link class="flex items-center px-1 py-2" :href="`/orders/${order.id}`" tabindex="-1">
                {{ order.hold_reason }}
              </Link>
            </td>
            <td class="border-t">
              <span v-if="role !== 'manager'">
                <select :id="`assigned_to_${order.id}`" disabled class="form-select mt-1 w-full">
                  <option value="0" :selected="!order.assigned_to">None</option>
                  <option v-for="user in users" :key="user.id" :value="user.id" :selected="order.assigned_to == user.id">{{ user.name }}</option>
                </select>
              </span>
              <select v-else :id="`assigned_to_${order.id}`" v-model="order.assigned_to" :disabled="!(order.status == 'new' || order.status == 'pending' || order.status == 'hold')" class="form-select mt-1 w-full" :class="{ 'border-red-400': !order.assigned_to }" @change="assign_user(order.id, order.assigned_to)">
                <option value="0" :selected="!order.assigned_to">None</option>
                <option v-for="user in users" :key="user.id" :value="user.id" :selected="order.assigned_to == user.id">{{ user.name }}</option>
              </select>
            </td>
            <td class="w-px border-t">
              <Link class="flex items-center px-1" :href="`/orders/${order.id}`" tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="orders.data.length === 0">
            <td class="empty-state" colspan="12">No orders found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="orders.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import axios from 'axios'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import {  startOfMonth } from 'date-fns'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
    Datepicker,
  },
  layout: Layout,
  props: {
    filters: Object,
    orders: Object,
    users: Array,
    assigned_to: Array,
    admin: Boolean,
    role: String,
  },
  computed: {
    selectAll: {
      get: function () {
        return this.orders.data ? this.selected.length === this.orders.data.length : false
      },
      set: function (value) {
        let selected = []

        if (value) {
          this.orders.data.forEach(function (order) {
            selected.push(order.id)
          })
        }

        this.selected = selected
      },
    },
  },
  created() {
    let params = (new URL(document.location)).searchParams
    let status = params.get('status')
    let unassigned = params.get('unassigned')
    let all = params.get('all')
    this.is_view_all_page = false

    //this.form.status = status

    if(status && status === 'new') {
      this.title = 'New Orders'
      return
    }

    if(status && status === 'pending') {
      this.title = 'Pending Orders'
      return
    }

    if(status && status === 'hold') {
      this.title = 'Orders to Followup'
      return
    }

    if(status && status === 'confirmed') {
      this.title = 'Confirmed orders (Non dispatched)'
      return
    }

    if(unassigned) {
      this.title = 'Orders to Assign'
      return
    }

    if(all) {
      this.title = 'All Orders'
      this.is_view_all_page = true
    }

  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/orders', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  data() {
    let params = (new URL(document.location)).searchParams
    let status = params.get('status')

    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        date: this.filters.date ?? [startOfMonth(new Date()), new Date()],
        //status: status,
        assigned_to: null,
      },
      assign: {
        order_id: null,
        user_id: null,
      },
      title : 'Orders',
      selected: [],
      is_view_all_page: false,
      mass_assigned_to: Number,
      view: status,
    }
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },

    self_assign() {
      this.$inertia.post('/orders/self_assign', {'order_ids': this.selected})
    },

    mass_assign() {
      if (this.mass_assigned_to === 0) {
        return
      }

      this.$inertia.post('/orders/mass_assign', {'order_ids': this.selected, 'to' : this.mass_assigned_to})
    },

    assign_user(order_id, user_id) {

      let params = (new URL(document.location)).searchParams
      let unassigned = params.get('unassigned')

      if(unassigned) {
        this.$inertia.post('/orders/'+order_id+'/assign', {'user_id' : user_id})
        return
      }

      //this.$inertia.put('/orders/'+order_id+'/assign', {'user_id' : user_id});
      var url =  '/orders/'+order_id+'/assign'
      axios({
        method: 'post',
        url:url,
        data: {'user_id' : user_id},
      }).then(function (response) {
        document.getElementById('order_'+order_id).classList.remove('hover:bg-gray-100')
        document.getElementById('order_'+order_id).classList.remove('focus-within:bg-gray-100')
        document.getElementById('order_'+order_id).classList.add('bg-green-100')

        setTimeout(() => {
          document.getElementById('order_'+order_id).classList.remove('bg-green-100')
          document.getElementById('order_'+order_id).classList.add('hover:bg-gray-100')
          document.getElementById('order_'+order_id).classList.add('focus-within:bg-gray-100')
        },1000)
      }).catch(function (error) {
        alert('Failed to save update. Please try again.')
        this.$inertia.reload({ only: ['orders', 'main-menu'] })
      })
    },
  },
}
</script>
